import { FC } from 'react'
import { useFormContext, useForm } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { get, isEmpty } from 'lodash';
import FormHelperText from '@mui/material/FormHelperText';

export interface IOptions {
    label: string;
    value: string;
    disable?: boolean;
}

// Interface for the Custom Checkbox Field props.
interface ICustomSelectProps {
    name: `${string}`;
    label: string;
    options: IOptions[];
    id: string;
    required?: boolean;
    selectedValue?: string | string[];
    multiple?: boolean;
    showNoneLabel?: boolean;
    [x: string]: any;
}

/**
 * Re-usable custom select component. 
 */
const CustomSelect: FC<ICustomSelectProps> = ({name, label, options, id, required = false, selectedValue, multiple, showNoneLabel = false, ...rest}) => {
    const { register, formState: { errors } } = useForm();
    const labelId = `${name}-label`;
    const error = get(errors, name);

    return (
        <FormControl fullWidth variant="outlined" error={!isEmpty(error)}>
            <InputLabel id={labelId}>{label}</InputLabel>
            <Select
                {...register(name)} {...rest}
                required={required}
                labelId={labelId}
                id={id}
                label={label} >
                {showNoneLabel && <MenuItem value="">
                    <em>None</em>
                </MenuItem>}
                {options.map(option => (
                    <MenuItem
                        value={option.value}
                        key={option.value}
                        disabled={option.disable || false}
                    >
                        {option.label}
                    </MenuItem>
                ))}
            </Select>
            {/* {!isEmpty(error) && <FormHelperText>{error?.message ?? ''}</FormHelperText>} */}
        </FormControl>
    );
}

export default CustomSelect;